/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActionSchedule } from './ActionSchedule';
import {
    ActionScheduleFromJSON,
    ActionScheduleFromJSONTyped,
    ActionScheduleToJSON,
    ActionScheduleToJSONTyped,
} from './ActionSchedule';

/**
 * 
 * @export
 * @interface ActionUpdateRequest
 */
export interface ActionUpdateRequest {
    /**
     * The unique identifier of the `Action` to update
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    id: string;
    /**
     * The type of this `Action`
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    actionType: ActionUpdateRequestActionTypeEnum;
    /**
     * The value for this `Action` (e.g. phone number, URL)
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    actionValue?: string;
    /**
     * Additional properties for this `Action`
     * @type {{ [key: string]: string; }}
     * @memberof ActionUpdateRequest
     */
    properties?: { [key: string]: string; };
    /**
     * The background color of the button
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    backgroundColor?: string;
    /**
     * Whether the icon is enabled
     * @type {boolean}
     * @memberof ActionUpdateRequest
     */
    iconEnabled?: boolean;
    /**
     * The CSS class for the icon
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    iconClass?: string;
    /**
     * The color of the icon
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    iconColor?: string;
    /**
     * The text shown in the icon
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    iconText?: string;
    /**
     * The type of icon to use
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    iconType?: ActionUpdateRequestIconTypeEnum;
    /**
     * URL of a background image for the icon
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    iconBackgroundImage?: string;
    /**
     * The background color of the label
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    labelBackgroundColor?: string;
    /**
     * The text shown in the label
     * @type {string}
     * @memberof ActionUpdateRequest
     */
    labelText?: string;
    /**
     * Optional schedule for when this `Action` is active
     * @type {ActionSchedule}
     * @memberof ActionUpdateRequest
     */
    schedule?: ActionSchedule;
}


/**
 * @export
 */
export const ActionUpdateRequestActionTypeEnum = {
    Anchor: 'ANCHOR',
    Email: 'EMAIL',
    Hours: 'HOURS',
    Link: 'LINK',
    Map: 'MAP',
    Phone: 'PHONE',
    Sms: 'SMS',
    Whatsapp: 'WHATSAPP',
    Facebook: 'FACEBOOK',
    Signal: 'SIGNAL',
    Telegram: 'TELEGRAM',
    Iframe: 'IFRAME',
    Tally: 'TALLY',
    Intercom: 'INTERCOM',
    Skype: 'SKYPE',
    Zalo: 'ZALO',
    Viber: 'VIBER',
    Line: 'LINE',
    Wechat: 'WECHAT',
    Chat: 'CHAT',
    Booking: 'BOOKING'
} as const;
export type ActionUpdateRequestActionTypeEnum = typeof ActionUpdateRequestActionTypeEnum[keyof typeof ActionUpdateRequestActionTypeEnum];

/**
 * @export
 */
export const ActionUpdateRequestIconTypeEnum = {
    Default: 'DEFAULT',
    Custom: 'CUSTOM',
    Font: 'FONT',
    Svg: 'SVG',
    FontMaterial: 'FONT_MATERIAL'
} as const;
export type ActionUpdateRequestIconTypeEnum = typeof ActionUpdateRequestIconTypeEnum[keyof typeof ActionUpdateRequestIconTypeEnum];


/**
 * Check if a given object implements the ActionUpdateRequest interface.
 */
export function instanceOfActionUpdateRequest(value: object): value is ActionUpdateRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('actionType' in value) || value['actionType'] === undefined) return false;
    return true;
}

export function ActionUpdateRequestFromJSON(json: any): ActionUpdateRequest {
    return ActionUpdateRequestFromJSONTyped(json, false);
}

export function ActionUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'actionType': json['actionType'],
        'actionValue': json['actionValue'] == null ? undefined : json['actionValue'],
        'properties': json['properties'] == null ? undefined : json['properties'],
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'iconEnabled': json['iconEnabled'] == null ? undefined : json['iconEnabled'],
        'iconClass': json['iconClass'] == null ? undefined : json['iconClass'],
        'iconColor': json['iconColor'] == null ? undefined : json['iconColor'],
        'iconText': json['iconText'] == null ? undefined : json['iconText'],
        'iconType': json['iconType'] == null ? undefined : json['iconType'],
        'iconBackgroundImage': json['iconBackgroundImage'] == null ? undefined : json['iconBackgroundImage'],
        'labelBackgroundColor': json['labelBackgroundColor'] == null ? undefined : json['labelBackgroundColor'],
        'labelText': json['labelText'] == null ? undefined : json['labelText'],
        'schedule': json['schedule'] == null ? undefined : ActionScheduleFromJSON(json['schedule']),
    };
}

export function ActionUpdateRequestToJSON(json: any): ActionUpdateRequest {
    return ActionUpdateRequestToJSONTyped(json, false);
}

export function ActionUpdateRequestToJSONTyped(value?: ActionUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'actionType': value['actionType'],
        'actionValue': value['actionValue'],
        'properties': value['properties'],
        'backgroundColor': value['backgroundColor'],
        'iconEnabled': value['iconEnabled'],
        'iconClass': value['iconClass'],
        'iconColor': value['iconColor'],
        'iconText': value['iconText'],
        'iconType': value['iconType'],
        'iconBackgroundImage': value['iconBackgroundImage'],
        'labelBackgroundColor': value['labelBackgroundColor'],
        'labelText': value['labelText'],
        'schedule': ActionScheduleToJSON(value['schedule']),
    };
}

